import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        question: '=',
        compareQuestion: '=',
        counter: '=',
        title: '=',
        compareTitle: '='
    },
    template: `
        <h4>{{ vm.counter }}. {{ vm.question.nameWithoutHtml }}</h4>
        <ul>
            <span class="title" ng-if="vm.compareTitle">
                <strong class="ng-binding">{{ vm.title }}</strong>
            </span>
            <li ng-repeat="answer in vm.question.answerOptions">{{ answer }}</li>
        </ul>
        <ul ng-if="vm.compareTitle && vm.compareQuestion">
            <span class="title">
                <strong class="ng-binding">{{ 'survey.Comparison' | translate }}</strong>
            </span>
            <li ng-repeat="answer in vm.question.answerOptions">{{ answer }}</li>
        </ul>
    `
})
export default class {
}



// WEBPACK FOOTER //
// ./src/app/components/survey/public/report/question/text/index.js